import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { CheckoutPage } from "./routes/CheckoutPage";
import { PixPage } from "./routes/PixPage";
import { ResultPage } from "./routes/ResultPage";
import "./styles.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function FrameHeightNotifier() {
  useEffect(() => {
    if (typeof window !== "undefined" && window.parent && window.parent !== window) {
      let lastHeight = 0;
      const sendHeight = () => {
        const root = document.getElementById("root");
        const main = root?.querySelector("main") || root;
        if (!main) return;
        const mainHeight = Math.ceil(main.getBoundingClientRect().height);
        const bodyHeight = document.body ? document.body.scrollHeight : 0;
        const docHeight = document.documentElement ? document.documentElement.scrollHeight : 0;
        const height = Math.max(mainHeight, bodyHeight, docHeight, 1400);
        if (height > 0 && Math.abs(height - lastHeight) > 8) {
          lastHeight = height;
          window.parent.postMessage({ type: "MELHOT_CHECKOUT_HEIGHT", height }, "*");
        }
      };

      sendHeight();
      const timer = setTimeout(sendHeight, 300);
      const timer2 = setTimeout(sendHeight, 1000);

      const observer = new ResizeObserver(() => {
        sendHeight();
      });

      const root = document.getElementById("root");
      if (root) observer.observe(root);

      return () => {
        clearTimeout(timer);
        clearTimeout(timer2);
        observer.disconnect();
      };
    }
  }, []);
  return null;
}

const queryClient = new QueryClient();

const container = document.getElementById("root");

if (container) {
  let targetContainer: Element = container;

  if (container.dataset.shadow === "true" && !container.shadowRoot) {
    const shadow = container.attachShadow({ mode: "open" });
    const cssUrl = (window as any).__MELHOT_CHECKOUT_CSS__ || "";
    if (cssUrl) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = cssUrl;
      shadow.appendChild(link);
    }
    const mountDiv = document.createElement("div");
    mountDiv.id = "shadow-checkout-app";
    shadow.appendChild(mountDiv);
    targetContainer = mountDiv;
  }

  ReactDOM.createRoot(targetContainer).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<CheckoutPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/cart" element={<CheckoutPage />} />
            <Route path="/pages/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/pix" element={<PixPage />} />
            <Route path="/cart/pix" element={<PixPage />} />
            <Route path="/checkout/success" element={<ResultPage status="success" />} />
            <Route path="/cart/success" element={<ResultPage status="success" />} />
            <Route path="/checkout/pending" element={<ResultPage status="pending" />} />
            <Route path="/checkout/error" element={<ResultPage status="error" />} />
            <Route path="*" element={<CheckoutPage />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>
  );
}
